import * as PolynomialDegreeTask from "./podtemat1_pojecie_types/PolynomialDegreeTask";
import * as PolynomialFeaturesTask from "./podtemat1_pojecie_types/PolynomialFeaturesTask";
import * as PolynomialProductFeaturesTask from "./podtemat1_pojecie_types/PolynomialProductFeaturesTask";
import * as PolynomialValueTask from "./podtemat1_pojecie_types/PolynomialValueTask";

export const registry = {
  PolynomialDegreeTask,
  PolynomialFeaturesTask,
  PolynomialProductFeaturesTask,
  PolynomialValueTask,
};

export function generateTasks(options = {}) {
  return [
    PolynomialDegreeTask.generateTask(options),
    PolynomialFeaturesTask.generateTask(options),
    PolynomialProductFeaturesTask.generateTask(options),
    PolynomialValueTask.generateTask({ ...options, variant: "integer" }),
    PolynomialValueTask.generateTask({ ...options, variant: Math.random() < 0.5 ? "fraction" : "sqrt" }),
  ];
}

function moduleFor(task) {
  const mod = registry[task?.type];
  if (!mod) throw new Error(`Nieznany typ zadania z pojęcia wielomianu: ${task?.type}`);
  return mod;
}

export function renderTask(task) {
  return moduleFor(task).renderTask(task);
}

export function renderInput(task, userAnswer, onChange, disabled) {
  return moduleFor(task).renderInput?.(task, userAnswer, onChange, disabled) ?? null;
}

export function checkAnswer(task, userAnswer) {
  return moduleFor(task).checkAnswer(task, userAnswer);
}

export function renderAnswer(task) {
  return moduleFor(task).renderAnswer(task);
}

export function renderExplanation(task) {
  return moduleFor(task).renderExplanation(task);
}

export function renderUserAnswer(userAnswer, task) {
  return moduleFor(task).renderUserAnswer?.(userAnswer, task) ?? null;
}
